import { render, staticRenderFns } from "./x-form-submit.vue?vue&type=template&id=55606770&scoped=true&"
import script from "./x-form-submit.vue?vue&type=script&lang=js&"
export * from "./x-form-submit.vue?vue&type=script&lang=js&"
import style0 from "./x-form-submit.vue?vue&type=style&index=0&id=55606770&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55606770",
  null
  
)

export default component.exports